import { requestProjectApi } from 'serviceWorker/api/requestApi';

/** The GDPR clause of the selected project's organization, as HTML in the worker's language. */
export function getGdprClause(): Promise<string> {
  return requestProjectApi({ method: 'GET', path: 'gdpr/clause', responseType: 'text' });
}
